import { css } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import { getKey } from '../../../helpers';
import { PINK } from '../../../constants/colors';

export default {
  container: ({ icon, theme }) => css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-image: url(${icon});
    background-repeat: no-repeat;
    background-size: ${theme.isWhite ? '55%' : 'contain'};
    background-position: 95% 0px;
    padding: 15px 15px;
    margin: 30px 0px;
    width: 100%;
    border-radius: 12px;
    ${media.sm`
      background-position: right;
      padding:0px 1.5vw;
      width: 100%;
    `};

    ${media.md`
      padding:0px 15px;
      width: 100%;
    `};
  `,
  innerwrapper: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 16px 16px 16px;
    height: 100%;
    width: 90%;
    margin: 16px auto;
    border-radius: 12px;
    ${theme.border
    && css`box-shadow: 0px 0px 2px 2px rgba(125, 125, 125, .5);`
    }
    ${media.sm`
      width:'100%';
    `}

  `,

  imageWrapper: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    max-height: 200px;
    width:100%;
    fit-content: cover;
    object-fit: cover;
  `,
  callToAction: ({ theme }) => css`
    display: flex;
    color: ${getKey(theme, 'secondary', PINK)};
    font-size: ${rem('14px')};
    line-height: ${rem('21px')};
    margin-top:auto;
    width:80%;
    text-align:center;
    justify-content:center;
    align-items: center;
    flex: 1;
    flex-grow:0;

    ${theme.button
    && css`
      background-color: ${getKey(theme, 'primary', PINK)};
      color: white;
      padding: 0.25em 1em;
      border-radius: 6px;
    `}

    &:hover {
      background-color: ${getKey(theme, 'hover', PINK)};
      color: white;
      text-decoration: none;
    }
  `,
  description: ({ theme }) => css`
    color: '#2D2F31';
    font-family: 'Gotham-Light',
    font-size: ${rem('16px')};
    line-height: ${rem('20px')};
    margin-top: 20px;
    text-align: center;
  `,
  title: ({ theme }) => css`
    color: ${getKey(theme, 'primary', 'white')};
    font-size: ${rem('26px')};
    line-height: ${rem('35px')};
    margin-bottom: 20px;

    ${media.sm`
       font-size:2.4vw;
       line-height:130%;
    `};

    ${media.md`
       font-size: ${rem('24px')};
       line-height: ${rem('37px')};
    `};
  `
};
